import { useEffect, useRef } from "react";

export const useOnClickOutside = (refOrRefs, handler) => {
  const refs = Array.isArray(refOrRefs) ? refOrRefs : [refOrRefs];
  const refsRef = useRef(refs);
  refsRef.current = refs;

  useEffect(() => {
    const listener = (event) => {
      const isInside = refsRef.current.some(
        (r) => r?.current && r.current.contains(event.target),
      );
      if (isInside) return;
      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [handler]);
};
